import { styled } from '@mui/material'
import MuiTabs from '@mui/material/Tabs'

export const Tabs = styled(MuiTabs)`
  margin-bottom: 16px;
  .MuiTabs-flexContainer {
    border-bottom: 1px solid #bdbdbd;
    height: 48px;
  }
`
